<template>
  <div class="aeVoucherTemplateList">
    <!-- 搜索 -->
    <sirui-search
      v-if="dictList.length > 10"
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/financeCenter/aeVoucherTemplate';
  // import DictSpan from '@/components/DictSpan';
  import tableMixins from '@/common/mixins/table.js';
  import { mapState } from 'vuex';
  export default {
    name: 'aeVoucherTemplateList',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      // DictSpan,
      SiruiTable,
    },
    computed: {
      searchColumns() {
        return [
          {
            name: '业务模块代码',
            prop: 'applicationCode',
            type: 'input',
            clearable: true,
          },
          {
            name: '业务实体代码',
            prop: 'entityCode',
            type: 'input',
            clearable: true,
          },
          {
            name: '事件分类代码',
            prop: 'eventCode',
            type: 'input',
            clearable: true,
          },
          {
            name: '凭证模板代码',
            prop: 'templateCode',
            type: 'input',
            clearable: true,
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
        dictList: (state) => state.dict.dictList,
      }),
    },
    data() {
      return {
        searchForm: {
          applicationCode: null,
          entityCode: null,
          eventCode: null,
          templateCode: null,
        },
        load: false,
        tableData: [],
        multipleSelection: [],
        menuButtonList: [],
        columnList: [],
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'applicationCode',
            title: '业务模块代码',
            visible: true,
          },
          {
            field: 'entityCode',
            title: '业务实体代码',
            visible: true,
          },
          {
            field: 'eventCode',
            title: '事件分类代码',
            visible: true,
          },
          {
            field: 'templateCode',
            title: '凭证模板代码',
            visible: true,
          },
          {
            field: 'templateName',
            title: '凭证模板名称',
            visible: true,
          },
          {
            field: 'templateDesc',
            title: '模板描述',
            visible: true,
          },
          {
            field: 'accountCondition',
            title: '取值逻辑',
            visible: true,
          },
          {
            field: 'enableFlag',
            title: '启用标志',
            visible: true,
          },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      async getData() {
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.searchForm, pageNum, pageSize };
        let res = await this.$axios.post(API.QUERY_AEVOUCHER_TEMPLATE_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        }
      },
      chooseClick(value) {
        if (value == 'add' || value == 'edit') {
          let [query, name] = [{}, 'editVoucherTemplate'];
          if (value == 'edit') {
            if (this.multipleSelection.length != 1) {
              this.$message({
                showClose: true,
                message: '请选择一条数据进行操作',
                type: 'error',
              });
            }
            [query, name] = [
              {
                type: 'edit',
                id: this.multipleSelection[0].id,
              },
              'editVoucherTemplate',
            ];
          }
          let path = {
            path: '/generalAccounting/' + name,
            name: name,
            meta: {
              keepAlive: true,
            },
            query: query,
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (value == 'del') {
          this.handleDel();
        }
      },
      // 删除/撤销弹框
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.$message({ showClose: true, type: 'error', message: '您还未选择任何数据!' });
        }
        let ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.id);
        });
        this.$confirmAction()
          .then(() => {
            this.del(ids);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 删除/撤销
      del(ids) {
        this.$axios.post(API.DELETE_AEVOUCHER_TEMPLATE, ids).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 列表双击
      dblclickEvent(value) {
        let path = {
          path: '/generalAccounting/editVoucherTemplate',
          name: 'editVoucherTemplate',
          meta: {
            keepAlive: false,
          },
          query: {
            type: 'query',
            id: value.row.id,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>

<style scoped></style>
